import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { fmtEUR, fmtPct } from "@/lib/format";

export const STATO = {
  ok: { label: "In linea", badge: "bg-[#8AA090]/15 text-[#4E6656]", bar: "#8AA090" },
  attenzione: { label: "Attenzione", badge: "bg-[#CBA368]/25 text-[#8A6A33]", bar: "#CBA368" },
  sforato: { label: "Sforato", badge: "bg-[#C0573F]/15 text-[#A2513C]", bar: "#C0573F" },
};

export const BudgetBar = ({ pct, stato }) => (
  <div className="h-2 rounded-full bg-[#F4EFEA] overflow-hidden">
    <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${Math.min(pct, 100)}%`, background: STATO[stato].bar }} />
  </div>
);

export function BudgetAlertsPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/budget/alerts").then((r) => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data?.count) return null;
  return (
    <section data-testid="budget-alerts-panel" className="rounded-2xl border border-[#CBA368]/40 bg-[#FFF9F0] p-5 sm:p-6 fade-up">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-5 w-5 text-[#B4553D]" />
          <h2 className="text-lg font-medium">Avvisi budget · {data.periodo.label}</h2>
          <span data-testid="budget-alerts-count" className="text-xs font-semibold px-2 py-0.5 rounded-full bg-[#C0573F] text-white">{data.count}</span>
        </div>
        <Link to="/budget" className="text-sm text-[#8C6D62] hover:underline" data-testid="budget-alerts-link">Gestisci budget →</Link>
      </div>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {data.items.map((b, i) => (
          <div key={b.id} data-testid={`budget-alert-${i}`} className="rounded-xl bg-white border border-[#EAE3DC] p-4">
            <div className="flex justify-between gap-2 text-sm">
              <span className="font-medium truncate">{b.categoria}{b.canale ? ` · ${b.canale}` : ""}</span>
              <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${STATO[b.stato].badge}`}>{STATO[b.stato].label}</span>
            </div>
            <div className="text-xs text-[#756B64] mt-1 mb-2 tabular">{fmtEUR(b.speso)} su {fmtEUR(b.importo)} · {fmtPct(b.percentuale)}</div>
            <BudgetBar pct={b.percentuale} stato={b.stato} />
          </div>
        ))}
      </div>
    </section>
  );
}
